import React from "react";
import { cn } from "@/lib/utils";

type GroupBookingPillProps = {
  className?: string;
};

/**
 * Pill rendered alongside `BookingTypePill` on staff-only views (admin + PM)
 * whenever `booking.isGroupBooking === true`. Indigo tone so it sits distinctly
 * next to the neutral grey booking-type pill in a row of metadata.
 */
const GroupBookingPill: React.FC<GroupBookingPillProps> = ({ className }) => {
  return (
    <span
      className={cn(
        "inline-block px-2 py-0.5 rounded-full bg-indigo-100 text-base font-semibold text-indigo-800",
        className,
      )}
      data-testid="group-booking-pill"
      title="This booking is a group session"
      aria-label="Group booking"
    >
      Group
    </span>
  );
};

export default GroupBookingPill;
